var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7C15.8807 7 17 5.88071 17 4.5C17 3.11929 15.8807 2 14.5 2C13.1193 2 12 3.11929 12 4.5C12 5.88071 13.1193 7 14.5 7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 7.6C12.9079 7.21056 12.445 6.98707 11.9584 7.00058C11.4718 7.01409 11.022 7.2629 10.7519 7.66795L6.75192 13.668C6.31033 14.3303 6.46312 15.2223 7.1 15.7L11.5 19H6C5.17157 19 4.5 19.6716 4.5 20.5C4.5 21.3284 5.17157 22 6 22H16C16.6456 22 17.2189 21.5869 17.423 20.9743C17.6272 20.3618 17.4165 19.6874 16.9 19.3L10.0352 14.1514L12.0721 11.0961L13.8 13.4C14.0609 13.7479 14.4599 13.9654 14.8937 13.9962C15.3274 14.0271 15.7532 13.8681 16.0607 13.5607L19.0607 10.5607C19.6464 9.97488 19.6464 9.02513 19.0607 8.43934C18.4749 7.85356 17.5251 7.85356 16.9393 8.43934L15.1623 10.2164L13.2 7.6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrayer);
export default __webpack_public_path__ + "static/media/prayer.f28ef3e2c2587b345295e20ae5ec4b90.svg";
export { ForwardRef as ReactComponent };